import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import AffiliateSetup from './affiliate.setup';
import AffiliateDefaultSetup from './affiliate_default.setup';
import Capacity from 'components/Capacity';

/**
 *   Create index file for affiliate
 */

export default function AffiliateSetupIndex() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = (
        <Capacity current_user_can={'manage_affiliates'} onFail={<Theme404 />}>
          <AffiliateSetup />
        </Capacity>
      );
      break;

    case 'default_setup':
      ActualPage = (
        <Capacity current_user_can={'manage_affiliates'} onFail={<Theme404 />}>
          <AffiliateDefaultSetup />
        </Capacity>
      );
      break;

    default:
      ActualPage = <Theme404 />;
      break;
  }

  return ActualPage;
}

